export default "__VITE_ASSET__4de68bea__"